<template>
  <CChartBar :datasets='dados' :labels='labels' :options='options' />
</template>

<script>
import { CChartBar } from '@coreui/vue-chartjs'

export default {
  name: 'GraficoBar',
  props: ['labels', 'dados', 'options'],
  components: { CChartBar },
  computed: {}
}
</script>



// WEBPACK FOOTER //
// src/components/GraficoBar.vue